import { useEffect, useState } from "react";
import api from "../services/api";
import { useNavigate } from "react-router-dom";

const InvoiceHistory = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  const [list, setList] = useState([]);
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const load = async () => {
    try {
      setLoading(true);

      const res = await api.get("/pos/invoices", {
        params: {
          from: from || undefined,
          to: to || undefined,
          invoice_number: invoiceNo || undefined
          // ❌ no branch_id here
        }
      });

      setList(res.data || []);
    } catch (err) {
      console.error("INVOICE HISTORY ERROR", err);
    } finally {
      setLoading(false);
    }
  };

  // Load once
  useEffect(() => {
    load();
  }, []);

  return (
    <div className="invoice-page">
      <h2>Invoice History</h2>

      {/* FILTER */}
      <div className="filter-bar no-print">
        <input
          type="date"
          value={from}
          onChange={e => setFrom(e.target.value)}
        />

        <input
          type="date"
          value={to}
          onChange={e => setTo(e.target.value)}
        />

        <input
          placeholder="Invoice No"
          value={invoiceNo}
          onChange={e => setInvoiceNo(e.target.value)}
        />

        <button onClick={load}>Search</button>
      </div>

      {/* TABLE */}
      <div className="invoice-table print-container">
        {loading ? (
          <div className="empty">Loading...</div>
        ) : (
          <table>
            <thead>
              <tr>
                <th>Invoice No</th>
                <th>Date</th>
                <th>Branch</th>
                <th>Total</th>
                <th className="no-print">Action</th>
              </tr>
            </thead>
            <tbody>
              {list.length === 0 && (
                <tr>
                  <td colSpan="5" className="empty">
                    No invoices found
                  </td>
                </tr>
              )}

              {list.map(inv => (
                <tr key={inv.invoice_id}>
                  <td>{inv.invoice_number}</td>
                  <td>
                    {new Date(inv.invoice_date).toLocaleString()}
                  </td>
                  <td>{inv.branch?.branch_name}</td>
                  <td>₹{inv.grand_total}</td>
                  <td className="no-print">
                    <button
                      className="primary-btn"
                      onClick={() =>
                        navigate(`/invoice/${inv.invoice_id}`)
                      }
                    >
                      View
                    </button>

                    <button
                      className="action-btn secondary"
                      onClick={() =>
                        navigate(`/print/${inv.invoice_id}`)
                      }
                    >
                      Re-Print
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default InvoiceHistory;
